<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="closeDialog">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" :selectable="checkSelectable" />
        <el-table-column prop="className" align="center" label="产品名称" />
        <el-table-column prop="num" align="center" label="数量" />
        <el-table-column prop="supplierName" width="150" align="center" label="供应商">
          <template slot-scope="scope">
            <div class="blue" @click="changeDealer(scope.row)">{{ scope.row.supplierName || '选择供应商' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="创建时间" />
        <el-table-column prop="isCompleted" align="center" label="是否完成采购" width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isCompleted" placeholder="请选择" size="small" @change="handleStatusChange(scope.row)" :class="scope.row.isCompleted === 1 ? 'status-completed' : 'status-uncompleted'">
              <el-option label="未采购" :value="0"></el-option>
              <el-option label="已采购" :value="1"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 采购人 -->
        <el-table-column prop="completedBy" align="center" label="采购人" />
      </el-table>
      <div class="pageBox">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
          :total="total" :pager-count="5" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="partialPurchase" v-if="hasUnpurchasedItems" :disabled="selectedRows.length === 0">部分采购</el-button>
        <el-button type="primary" @click="confirmAddCustomer" :disabled="hasUnpurchasedItems">完成采购</el-button>
      </span>
    </el-dialog>
    <!-- 绑定经销商 -->
    <bindDealerDialog ref="bindDealerDialog" @success="handleDearlar"></bindDealerDialog>
  </div>
</template>

<script>
  import { getPurchase, queryList, listByType, completePurchase, updatePurchaseStatus } from '@/api/boomClass.js'
  import bindDealerDialog from '../component/bindDealerDialog'
  import { baseUrl } from "@/utils/index"

  export default {
    name: "addPageClass",
    components: { bindDealerDialog, },
    props: [],
    data() {
      let token = localStorage.getItem("token")
      return {
        fileList: [],
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        upParams: {
          token: token
        },
        provinces: [],
        classType: null,
        dialogVisible: false,
        title: '',
        tableData: [],
        rules: {},
        excleId: '',
        pageSize: 10,
        pageNum: 1,
        total: 0,
        selectedRows: [], // 存储选中的行
      };
    },
    computed: {
      // 判断是否有未采购的项目
      hasUnpurchasedItems() {
        if (!this.tableData || !Array.isArray(this.tableData) || this.tableData.length === 0) {
          return false
        }
        return this.tableData.some(item => item.isCompleted === 0)
      }
    },
    onShow() { },
    // mounted() {
    //   this.resetForm()
    // },
    methods: {
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.resetForm(this.excleId);
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.resetForm(this.excleId);
      },
      async open(dat) {
        console.log(dat);
        // this.ruleForm={}
        this.excleId = dat.id
        this.dialogVisible = true
        this.title = '采购清单列表'
        this.selectedRows = [] // 清空选中行
        this.resetForm(dat.id)
      },
      handleDearlar() {
        this.resetForm(this.excleId)
      },
      resetForm(id) {
        let param = {
          excelId: id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        listByType(param).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
          console.log(this.tableData);
        })
      },
      closeDialog() {
        this.dialogVisible = false
      },
      changeDealer(item) {
        console.log(item);
        this.$refs.bindDealerDialog.open(item)
      },
      // 处理表格选中变化
      handleSelectionChange(selection) {
        this.selectedRows = selection
      },
      // 检查行是否可选（只有未采购的可以选择）
      checkSelectable(row) {
        return row.isCompleted === 0
      },
      // 处理状态变化 - 下拉框选择后立即触发
      handleStatusChange(row) {
        const bomOutList = [{
          id: row.id,
          isCompleted: row.isCompleted
        }]
        
        // 调用API保存数据
        updatePurchaseStatus(bomOutList).then(res => {
          if (res.code === 200) {
            this.$message.success('状态更新成功')
            this.resetForm(this.excleId) // 刷新列表
            this.$emit('getList') // 通知父组件刷新
          } else {
            this.$message.error(res.message || '状态更新失败')
            // 失败后恢复原状态
            this.resetForm(this.excleId)
          }
        }).catch(err => {
          this.$message.error('请求失败，请稍后再试')
          console.error('Error:', err)
          // 失败后恢复原状态
          this.resetForm(this.excleId)
        })
      },
      // 部分采购
      partialPurchase() {
        if (this.selectedRows.length === 0) {
          this.$message.warning('请选择要标记为已采购的项目')
          return
        }
        
        // 准备更新数据 - 将选中的项标记为已采购
        const bomOutList = this.selectedRows.map(item => ({
          id: item.id,
          isCompleted: 1 
        }))
        
        // 调用API保存数据
        updatePurchaseStatus(bomOutList).then(res => {
          if (res.code === 200) {
            this.$message.success('部分采购状态已更新')
            this.selectedRows = [] // 清空选中
            this.dialogVisible = false // 关闭弹窗
            this.$emit('getList') // 通知父组件刷新
          } else {
            this.$message.error(res.message || '更新失败')
          }
        }).catch(err => {
          this.$message.error('请求失败，请稍后再试')
          console.error('Error:', err)
        })
      },
      confirmAddCustomer() {
        // 检查是否所有产品都已采购
        if (this.hasUnpurchasedItems) {
          this.$message.warning('请先将所有产品标记为已采购')
          return
        }
        
        let param = {
          excleId: this.excleId
        };
        completePurchase(param).then(res => {
          // 检查响应的 code 和 message
          if (res.code === 200) { // 假设 200 是成功的状态码
            this.$message({
              type: 'success',
              message: res.message || '提交成功!'
            });
            this.dialogVisible = false;
            this.$emit('getList') // 通知父组件刷新
          } else {
            // 如果 code 不是 200，展示错误消息
            this.$message({
              type: 'error',
              message: res.message || '提交失败!'
            });
          }
        }).catch(error => {
          console.error('Error:', error);
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .component {
    margin-bottom: 10px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .accessory {
    margin-bottom: 10px;
    padding-left: 20px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .sub-accessory {
    margin-bottom: 10px;
    padding-left: 40px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .blue {
    color: #51CBCD;
    cursor: pointer;

  }

  /* 采购状态颜色 */
  .status-completed ::v-deep .el-input__inner {
    color: #67C23A;
    font-weight: bold;
  }

  .status-uncompleted ::v-deep .el-input__inner {
    color: #F56C6C;
    font-weight: bold;
  }
</style>